import { Platform, PermissionsAndroid } from 'react-native'
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import * as DocumentPicker from 'expo-document-picker'
import md5 from 'md5'
import mime from 'mime'
import pathParse from 'path-parse'
import AsyncStorage from '@react-native-community/async-storage'
import { launchImageLibrary, launchCamera } from 'react-native-image-picker'

const MediaType = 'audiovideo'
const ImageType = 'image'
const DocumentType = 'document'
const PDFType = 'pdf'

function get_mime_extension(mimeType) {
  return mime.getExtension(mimeType)
}
function get_url_extension(url) {
  return url.split(/[#?]/)[0].split('.').pop().trim()
}

const MediaHelper = {
  get_url_extension,
  get_mime_extension,
  getBlobFromDataURL: async (dataURL) => {
    const blob = await fetch(dataURL).then((res) => res.blob())
    const payload = blob
    return payload
  },
  getMedia: (mediaType, returnReference = true, forceCamera = false) => {
    const offline_id = uuidv4()

    // eslint-disable-next-line no-async-promise-executor
    const p = new Promise(async (resolve, reject) => {
      let result
      let filename

      try {
        switch (mediaType) {
          case PDFType:
            result = await DocumentPicker.getDocumentAsync({
              type: '*/*'
            })
            filename = _.get(result, 'file.name', 'file')
            break
          case MediaType:
          case DocumentType:
            {
              result = await DocumentPicker.getDocumentAsync({
                type: '*/*'
              })
              const localFilename = _.get(result, 'file.name', 'file')
              filename = localFilename
            }
            break
          case ImageType:
            // Camera permissions for Android
            if (forceCamera) {
              if (Platform.OS === 'android') {
                const granted = await PermissionsAndroid.request(
                  PermissionsAndroid.PERMISSIONS.CAMERA,
                  {
                    title: 'Camera Permission',
                    message: 'App needs camera permission to take photos.',
                    buttonNeutral: 'Ask Me Later',
                    buttonNegative: 'Cancel',
                    buttonPositive: 'OK'
                  }
                )
                if (granted !== PermissionsAndroid.RESULTS.GRANTED) {
                  alert('Please allow camera access to continue.')
                  return
                }
              }
              const cameraOptions = {
                mediaType: 'photo',
                quality: 0.5,
                includeBase64: true
              }
              const cameraResult = await launchCamera(cameraOptions)
              if (cameraResult.didCancel) {
                throw new Error('User cancelled.')
              }
              if (cameraResult.errorCode) {
                throw new Error(cameraResult.errorMessage)
              }
              result = cameraResult.assets[0]
            } else {
              const libraryOptions = {
                mediaType: 'photo',
                quality: 0.5,
                includeBase64: true
              }
              const libraryResult = await launchImageLibrary(libraryOptions)
              if (libraryResult.didCancel) {
                throw new Error('User cancelled.')
              }
              if (libraryResult.errorCode) {
                throw new Error(libraryResult.errorMessage)
              }
              result = libraryResult.assets[0]
            }
            break
        }
      } catch (err) {
        console.warn(err)
        reject(err)
        throw err
      }

      let payload

      const pathElements = pathParse(result.uri)
      result.type = mime.getType(result.uri)

      if (Platform.OS === 'web') {
        const startOfBase64 = result.uri.substring(
          result.uri.indexOf(':') + 1,
          result.uri.indexOf(';')
        )
        const extension = mime.getExtension(startOfBase64)
        filename = filename ?? 'Image.' + extension
      } else {
        filename = pathElements.name + pathElements.ext
      }
      result.name = filename
      result.md5 = md5(result.uri)

      if (returnReference) {
        if (Platform.OS === 'web') {
          localStorage.setItem(result.md5, result.uri)
        } else {
          await AsyncStorage.setItem(result.md5, result.uri)
        }
        result.uri = ''
        delete result.base64
      }

      payload = result
      resolve({ payload, filename, offline_id })
    })

    return p
  },
  ImageType,
  MediaType,
  DocumentType,
  PDFType
}
export default MediaHelper
